<style src="./BidMirror.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="bid-capture">
    <button
      class="btn btn-primary"
      @click="openBidMirror">
      Ir para o espelho do edital
      </button>
  </section>
</template>

<script>
export default {
  name: 'BidMirror',
  props: {
    stageId: null,
    eventId: null
  },
  data () {
    return {
      declineReason: ''
    }
  },
  methods: {
    openBidMirror () {
      this.$router.push({ name: 'BidMirror', params: { eventId: this.eventId } })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/event/bid-mirror/BidMirror.vue